module.exports = __webpack_public_path__ + "img/E-WEB-Goal-08.ef427802.svg";